// 转换文件为Base64
export const getBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

// 预加载图片
export const preloadImage = (url: string) => {
  const img = new Image();
  img.src = url;
};

// 生成视频缩略图
export const generateVideoThumbnail = (
  file: File,
  getErrorMessage: (id: string) => string
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    video.onloadedmetadata = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      video.currentTime = 1; // 获取第1秒的帧
    };

    video.onseeked = () => {
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", 0.8));
      } else {
        reject(new Error(getErrorMessage("video.thumbnail.generate.error")));
      }
    };

    video.onerror = () => reject(new Error(getErrorMessage("video.load.error")));
    video.src = URL.createObjectURL(file);
  });
};
